// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V7_XVcyOVsKN1UQe7K7P {
  height: 100%;
  width: 100%;
  display: flex;
}
.V7_XVcyOVsKN1UQe7K7P .JdXlNzfUKAC5YMiJXuFT {
  flex: 0 0 48px;
  width: 48px;
  border-right: 1px solid #d2d2d2;
  padding-top: 10px;
}
.V7_XVcyOVsKN1UQe7K7P .JdXlNzfUKAC5YMiJXuFT .DFxhds1lYJxQvknVx1bw {
  padding: 10px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
}
.V7_XVcyOVsKN1UQe7K7P .JdXlNzfUKAC5YMiJXuFT .DFxhds1lYJxQvknVx1bw.IM18QHf8V8DF9pdYBtgl,
.V7_XVcyOVsKN1UQe7K7P .JdXlNzfUKAC5YMiJXuFT .DFxhds1lYJxQvknVx1bw:hover {
  color: '#037C4B';
  background: #f0f8ff;
}
.V7_XVcyOVsKN1UQe7K7P .brB5ihv2DgZ5kgsanj6k {
  height: 100%;
  flex: auto;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Task/index.module.less"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,WAAA;EACA,aAAA;AADF;AAFA;EAMI,cAAA;EACA,WAAA;EACA,+BAAA;EACA,iBAAA;AADJ;AARA;EAYM,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AADN;AAGM;;EAEE,gBAAA;EACA,mBAAA;AADR;AAnBA;EA0BI,YAAA;EACA,UAAA;EACA,cAAA;AAJJ","sourcesContent":["@import '../../../styles/var.less';\n\n.container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n\n  .sider {\n    flex: 0 0 48px;\n    width: 48px;\n    border-right: 1px solid #d2d2d2;\n    padding-top: 10px;\n\n    .siderItem {\n      padding: 10px;\n      text-align: center;\n      cursor: pointer;\n      font-size: 16px;\n\n      &.active,\n      &:hover {\n        color: @primary-color;\n        background: #f0f8ff;\n      }\n    }\n  }\n\n  .content {\n    height: 100%;\n    flex: auto;\n    overflow: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `V7_XVcyOVsKN1UQe7K7P`,
	"sider": `JdXlNzfUKAC5YMiJXuFT`,
	"siderItem": `DFxhds1lYJxQvknVx1bw`,
	"active": `IM18QHf8V8DF9pdYBtgl`,
	"content": `brB5ihv2DgZ5kgsanj6k`
};
export default ___CSS_LOADER_EXPORT___;
